export const DEQ_PAGE_TYPES: { [key: string]: string } = {
  article: 'article',
  'home-page': 'home',
  home: 'home',
  search: 'search',
  'product-page': 'product',
  form: 'form',
  logIn: 'log-in',
  logOut: 'log-out',
  campaign: 'campaign',
  index: 'index',
  service: 'service',
  error: 'error',
  contact: 'contact',
  'contact-form-page': 'contact',
  'gated-contact-page': 'form',
  generic: 'generic',
  action: 'action',
};

export const DEQ_FORMS: { [key: string]: 'contact' | 'download' } = {
  contact: 'contact',
  download: 'download',
};

export const DEQ_TYPES = {
  mainNavigation: 'navigation-header',
  mainNavigationClose: 'navigation-header-close',
  btnMenu: 'menu',
  container: 'container',
  button: 'button',
  textLink: 'textlink',
  topNavigation: 'navigation-top',
  image: 'image',
  logo: 'logo',
  btnLink: 'button',
  btnImage: 'image',
  primaryAnkeiler: 'primary-ankeiler',
  secondaryAnkeiler: 'secondary-ankeiler',
  foldout: 'foldout',
  contactForm: 'contact-form',
  breadcrumb: 'breadcrumb',
  btnCard: 'card',
  topResultsCta: 'top-results-cta',
  tag: 'tag',
  tab: 'tab',
  btnTab: 'btn-tab',
  articleFilter: 'article-filter',
  formInput: 'form-input',
  radio: 'radiobutton',
  richTextHtml: 'rich-text',
  info: 'info',
  headerWrapper: 'HeaderWrapper',
  navigationContainer: 'NavigationContainer',
  contentControl: 'content-control',
};

export const DEQ_ERROR_TYPES = {
  technical: 'technical',
  business: 'business',
  user: 'user',
  required: 'required-error',
};

export const DEQ_COMPS = {
  articlePreviewTag: 'article-preview-tag',
  feedbackForm: 'feedback-form',
  articleLayout: 'article-layout',
  calculator: 'calculator',
  headerCtaCard: 'header-cta-card',
  productOverviewCard: 'product-overview-card',
  usp: 'usp',
  videoCta: 'video-cta',
  leadForm: 'lead-form',
  themeCtaCard: 'theme-cta-card',
  contactForm: 'contact-form',
  staticWizardAside: 'static-wizard-aside',
  staticWizardForm: 'static-wizard-form',
  staticWizardResults: 'static-wizard-results',
  wizardContactForm: 'wizard-contact-form',
  wizardIntro: 'wizard-intro',
  wizardResult: 'wizard-result',
  wizardResultHeader: 'wizard-result-header',
  wizardStep: 'wizard-step',
  wizardTab: 'wizard-tab',
  footer: 'footer-underdoormat',
  navigatorBreadcrumb: 'navigation-breadcrumb',
  tooltip: 'tooltip',
  gatedContentForm: 'gated-content-form',
  wizardRippleHeader: 'wizard-ripple-header',
  productCard: 'product-card',
  productRippleHeader: 'product-ripple-header',
  socialProofWrapper: 'social-proof-wrapper',
};

export const FORM_TRACKING = {
  stepName: 'form step',
  version: 'v1',
  stepStart: '10',
  stepEnd: '20',
  endSuccess: 'end-success',
};
